import React from 'react';
import Loadable from 'react-loadable';

import LoadableLoading from 'components/LoadableLoading';
import { IProps } from './interface';

export const path = '/chrona/settings';

const PageChronaSettings: React.FC<IProps> = (props) => {
  const LoadableMap = Loadable.Map({
    loader: {
      page: () => import('./page'),
      i18n: () => import('./ru.json'),
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page i18n={loaded.i18n} {...props} {...loadedProps} />;
    },
  });

  return <LoadableMap {...props} />;
};

export default PageChronaSettings;
